// Částka ve formátu „1 234,00" – mezera jako oddělovač tisíců, čárka před desetinami,
// vždy dvě desetinná místa a bez měny, ať je zobrazení připravené i na přechod na eura.
export default function formatMoney(value) {
	const n = Number(value) || 0;
	const [intPart, decPart] = Math.abs(n).toFixed(2).split('.');
	const grouped = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

	return `${n < 0 ? '-' : ''}${grouped},${decPart}`;
}
